import Grid from '@mui/material/Grid';
import "./style.css";
import React from 'react';
import {useState, useEffect, useRef} from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import { purple } from '@mui/material/colors';
import Divider from '@mui/material/Divider';
import axios from 'axios';
import { Search } from "@mui/icons-material";
import { IconButton} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';

export default function Signature({currPreview, closeOpenSignature}){
    const [error, setError] = useState()
    //Signature File Upload Starts Here
    const [uploadedSignatureStat, setUploadedSignatureStat] = useState(false);
    const [fileSignature, setSignatureFile] = useState(null);
    const [SignaturefileName, setSignatureFileName] = useState("");
  const handleSignatureFileChange = (event) => {
    setSignatureFile(event.target.files[0]);
    setSignatureFileName(event.target.files[0].name);
    setUploadedSignatureStat(true);
  };

  const clearSignatureFile = (event)=>{
    setSignatureFile(null);
    setSignatureFileName("");
    setUploadedSignatureStat(false);
  }
  const [sayaYakin,setSayaYakin] = useState()
  const [namaSaya,setNamaSaya] = useState()

  const handleSignatureUploadButtonClick = () => {
    fileInputSignature.current.click();
  };
  const fileInputSignature = useRef(null);
//Signature File Upload Ends Here
//Upload TTD
const uploadTTD = (event) => {
    if(sayaYakin !== "Saya Yakin"){
        setError("Ketik Saya Yakin")
    }else{

        if(fileSignature !== null){
            if(namaSaya){
                //Insert what to do if everything pass

                //Upload File to Amazon S3
                // Assuming that fileKTP and fileNPWP are your file objects
                    const filesToUpload = [
                        { file: fileSignature, name: 'fileSignature' },
                    ];
            
                    // Map over the files array and return an array of promises
                    const uploadPromises = filesToUpload.map((fileObj) => {
                        const fileType = fileObj.file.type;
                        if (fileObj.file) { // if the file is not null, upload it
                        return axios.get(`${process.env.REACT_APP_BACKEND_URL}/getUploadURL?fileType=${fileType}`, {
                        })
                        .then(response => {
                            const uploadUrl = response.data.url;
                            const key = response.data.key; // Get the key from the response
            
                            return fetch(uploadUrl, {
                            method: 'PUT',
                            headers: {
                                'Content-Type': fileObj.file.type
                            },
                            body: fileObj.file
                            }).then(() => key); // After the file is uploaded, return the key
                        })
                        .catch(error => {
                            console.error('Error during file upload:', error);
                        });
                        }
            
                        // if the file is null, return a resolved promise with value null
                        return Promise.resolve(null);
                    });

                    Promise.all(uploadPromises)
                    .then(fileKeys => {
                      const [signatureKey] = fileKeys; // Extract keys from the resolved values array
                        //Save key in an array for the specific contract and change post.signature to Pending..
                        axios.post(`${process.env.REACT_APP_BACKEND_URL}/DomisiliUpload`, {
                            signatureKey, id:currPreview._id
                          })
                          .then((response) => {
                            console.log("waiting for approval for signature")
                            window.location.reload();
                          })
                    }).catch(error => {
                        console.error("Error during file upload:", error);
                      });
                


            }else{
                setError("Masukkan Nama Kamu")
            }

        }else{
            setError("Upload File")
        }
    }
}
    return <Grid sx={{m:2}}>
    
    <p>Upload File Domisili Kokas:</p>
    <div style={{ display: 'flex', alignItems: 'center' }}>
              <input
                type="file"
                ref={fileInputSignature}
                onChange={handleSignatureFileChange}
                style={{ display: 'none' }}
              />
              <Button sx={{mb:3}}
                color={uploadedSignatureStat ? "success" : "primary"}
                variant="contained"
                onClick={handleSignatureUploadButtonClick}
                style={{ marginRight: '8px' }}
              >
                Domisili Kokas BM
              </Button>
              <Typography variant="body1" style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {SignaturefileName.length > 20 ? `${SignaturefileName.slice(0, 17)}...` : SignaturefileName}
              </Typography>
              {uploadedSignatureStat && (
                <IconButton size="small" onClick={clearSignatureFile}>
                  <CloseIcon />
                </IconButton>
              )}
            </div>
    <p>Ketik "Saya Yakin" dibawah</p>
    <TextField onChange={(event)=>setSayaYakin(event.target.value)} value={sayaYakin}></TextField>
    <p>Ketik Nama kamu dibawah:</p>
    <TextField value={namaSaya} onChange={(event)=> setNamaSaya(event.target.value)}></TextField>
    <Grid xs={12} sx={{mt:5}}>
    {error && <Grid className="error_text" sx={{mb:3}}>{error}</Grid>}
    <Button onClick={uploadTTD} variant="contained">Simpan</Button>
    </Grid>
    </Grid>
}